export * from './info-badge.component';
